export enum ElpPromotionFilter {
  All = 'all',
  Available = 'available',
  Enrolled = 'enrolled',
}
